import { withStyles, Theme, createStyles, TableCell, TableHead, TableRow, Checkbox, TableSortLabel } from "@material-ui/core";
import { mdiChevronDown, mdiChevronUp } from "@mdi/js";
import classes from './index.module.css';
import Icon from "@mdi/react";

type Ord = 'asc' | 'desc';
interface Props {
  onSort: (
    event: React.MouseEvent<unknown>,
    property: string | number | symbol
  ) => void;
  order: Ord;
  orderBy: string | number | symbol;
  rowCount: number;
  headCells: any[]
  onSelectAll?: (e:React.ChangeEvent<HTMLInputElement>) => void;
  numSelected: number
  action?: boolean
}

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      padding: '10px 0',
      backgroundColor: '#d3d6e8 !important',
      color: '#212121',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
  })
)(TableCell);

function RonadTableHead(props: Props) {
  const { order, orderBy, onSort, action, headCells, numSelected, rowCount, onSelectAll } = props;

  const createSortHandler = (property: string | number | symbol) => (
    event: React.MouseEvent<unknown>
  ) => {
    onSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {onSelectAll && <StyledTableCell>
          <Checkbox
            indeterminate={
              numSelected > 0 && numSelected < rowCount
            }
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAll}
            inputProps={{ 'aria-label': 'select all desserts' }}
            disableRipple={true}
            // style={{ color: '#fff' }}
          />
        </StyledTableCell>}
        {headCells.map(headCell => (
          <StyledTableCell
            key={headCell.id}
            align="center"
            sortDirection={orderBy === headCell.id ? order : false}
            data-cy={headCell.id}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              classes={{
                // Override with the active class if this is the selected column or inactive otherwise
                icon:
                  orderBy === headCell.id
                    ? classes.activeSortIcon
                    : classes.inactiveSortIcon,
              }}
              IconComponent={() => (
                <Icon
                  path={
                    orderBy === headCell.id && order === 'desc'
                      ? mdiChevronDown
                      : mdiChevronUp
                  }
                  size={0.7}
                  className={
                    orderBy === headCell.id
                      ? classes.activeSortIcon
                      : classes.inactiveSortIcon
                  }
                />
              )}
            >
              {headCell.label}
            </TableSortLabel>
          </StyledTableCell>
        ))}
        {action && <StyledTableCell />}
      </TableRow>
    </TableHead>
  );
}

export default RonadTableHead;